import XmlTesterComponent from "../../modules/xml-tester/xml-tester";

export default function XMLTester() {
    return <div className="p-4"><XmlTesterComponent role="open" /></div>;
}